import React from "react";
import './loading.css'
const Loading = () => {
  return (
    <div className="loading-page">
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;
